<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="page_2"></a><a id="page_3"></a><span class="small">THE</span><br/>BOOK<br/><span class="small">OF</span><br/>KNIGHTS</h1>
<p class="imagea"><img alt="title" src="images/title.jpg"/></p>
<p class="author">YVES MEYNARD</p>
<p class="publisher"><img alt="pub" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?78d872ea